// extracted by mini-css-extract-plugin
export default {"orderItem":"orderItem_orderItem__UvQMc","show":"orderItem_show__g9nKE"};